import { render, staticRenderFns } from "./IndexCaseStudySection.vue?vue&type=template&id=4082bc23&scoped=true"
import script from "./IndexCaseStudySection.vue?vue&type=script&lang=js"
export * from "./IndexCaseStudySection.vue?vue&type=script&lang=js"
import style0 from "./IndexCaseStudySection.vue?vue&type=style&index=0&id=4082bc23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4082bc23",
  null
  
)

export default component.exports